export default __webpack_public_path__ + "static/media/cat-003.ecd731a1.svg";